import ClinicalProcess from './ClinicalProcess'

export default class Search extends ClinicalProcess {
	static fromJSON(json) {
		if (!json) return null
		return new Search(json)
	}

	constructor(json) {
		super(json)

		return { ...this.id, requisitionId: json.requisitionId }
	}
}
